import styles from './FJImageToImageRight.module.less';
import PropTypes from 'prop-types';
import FJDragBox from '../../../common/components/FJDragBox/FJDragBox';
import FJDisplayHeaderContainer from '../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer';
import FJCreationPanelContainer from '../../FJMainPreview/FJCreationPanel/FJCreationPanelContainer';
import FJHistoryPanelContainer from '../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer';
import classNames from 'classnames';

const FJImageToImageRight = props => {
    const { uploadImg, setIsDraggingFile, isEmptyCreationList, headerTabIndex } = props;

    return (
        <FJDragBox
            setIsDragging={setIsDraggingFile}
            uploadFile={uploadImg}
            className={classNames(
                styles.app_right,
                isEmptyCreationList && headerTabIndex === 0 && styles.empty_creation_list,
            )}
        >
            <FJDisplayHeaderContainer isShowProgress={false} isHideBottomLine={isEmptyCreationList} />

            <FJCreationPanelContainer activeHeaderTabIndex={0} />

            <FJHistoryPanelContainer activeHeaderTabIndex={1} />
        </FJDragBox>
    );
};

FJImageToImageRight.propTypes = {
    uploadImg: PropTypes.func,
    setIsDraggingFile: PropTypes.func,
    isEmptyCreationList: PropTypes.bool,
    headerTabIndex: PropTypes.number,
};

export default FJImageToImageRight;
